module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.currentItems.length) ? _c('MentoringRequestList', {
    attrs: {
      "items": _vm.currentItems
    }
  }) : _c('Warning', [_c('p', [_vm._v(_vm._s(_vm.warningText))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-540221fd","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profile/modules/mentoring/views/currentrequests/MentoringCurrentRequests.vue
// module id = 56c0a1a74f76964c0595
// module chunks = 59